export const API_URL = process.env.VUE_APP_API_URL;
export const BASE_MEDIA_URL = process.env.VUE_APP_BASE_MEDIA_URL;

/* AUTH */
export const URL__AUTH_LOGIN = '/admins/auth/email';
export const URL__AUTH_PASSWORD_RESET = '/admins/reset-password';
export const URL__AUTH_PASSWORD_FORGOT = '/admins/reset-password';
export const DEFAULT_PAGINATION = 3;
